module.exports = __webpack_public_path__ + "img/comment-blue.58900501.svg";